import SettingsDivider from './SettingsDivider';

export default SettingsDivider;
